<template>
  <div
    v-if="isShow"
    class="select-color"
    :style="boxStyle"
    @mousedown.stop
  >
    <div class="select-color-header">
      选择颜色
    </div>
    <div class="recent-color-box">
      <div>最近使用</div>
      <ul>
        <li
          v-for="(c, i) in recentColors"
          :key="i"
          :style="{ backgroundColor: c }"
          @click="onClickRecentColor(c)"
        ></li>
      </ul>
    </div>
    <div class="color-picker-box">
      <color-picker
        ref="pickerRef"
        v-model="colors"
        @childChange="childChange"
      ></color-picker>
    </div>
    <div class="select-color-btn">
      <div @click="cancel">
        取消
      </div>
      <div @click="sure">
        确定
      </div>
    </div>
  </div>
</template>
<script>
import colorPicker from '@/components/common/colorPicker';

let defaultProps = {
  hex: '#194d33',
  rgb: {
    r: 159,
    g: 96,
    b: 43
  }
};

export default {
  name: 'SelectColor',
  components: {
    colorPicker
  },
  props: {
    types: {
      type: Array,
      required: true
    },
    info: {
      type: Object,
      required: true,
      default: function() {
        return {};
      }
    },
    updateInfo: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data() {
    return {
      isShow: false,
      box: {
        x: 0,
        y: 0,
        zIndex: 10
      },
      recentColors: [],
      colors: defaultProps,
      color: '',
      disableAlpha: false,
      callback: null
    };
  },
  computed: {
    boxStyle() {
      const style = {};
      style.top = this.box.y + 'px';
      style.left = this.box.x + 'px';
      style.zIndex = this.box.zIndex;
      return style;
    }
  },
  watch: {
    types() {
      if (this.types.indexOf('selectColor') > -1) {
        this.isShow = true;
        this.initData();
      } else {
        this.isShow = false;
        this.callback = null;
      }
    },
    updateInfo() {
      if (!this.isShow) return;
      this.initData();
    }
  },
  mounted() {
    this.$bus.on('eyedropper', this.eyedropper);
  },
  beforeDestroy() {
    this.$bus.off('eyedropper', this.eyedropper);
  },
  methods: {
    initData() {
      let info = this.info.selectColor;
      this.box.x = info.x || 0;
      this.box.y = info.y || 0;
      this.box.zIndex = info.zIndex || 10;
      this.color = info.color;
      if (this.color) {
        this.$nextTick(() => {
          this.$refs.pickerRef.handlePreset(this.color);
        });
      }
      if (info.callback) {
        this.callback = info.callback;
      }
    },
    eyedropper(data) {
      if (data.type === 'mousedown') {
        this.$refs.pickerRef.handlePreset(data.color);
      }
    },
    childChange() {
      if (this.callback) {
        this.callback(this.colors.hex);
      }
    },
    onClickRecentColor(c) {
      this.$refs.pickerRef.handlePreset(c);
    },
    sure() {
      if (this.color === this.colors.hex) {
        this.$emit('close', { type: 'selectColor' });
        return;
      }
      this.setRecent();
      if (this.callback) {
        this.callback(this.colors.hex);
      }
      this.$emit('close', { type: 'selectColor' });
    },
    cancel() {
      if (this.callback) {
        this.callback(this.color);
      }
      this.$emit('close', { type: 'selectColor' });
    },
    setRecent() {
      if (this.recentColors.length >= 5) {
        this.recentColors.splice(4, this.recentColors.length - 4);
      }
      this.recentColors.unshift(this.colors.hex);
    }
  }
};
</script>
<style lang="scss" scoped>
.select-color {
  width: 330px;
  height: 474px;
  color: #333333;
}
.select-color-header {
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-weight: bold;
  text-align: left;
  padding-left: 30px;
  border-bottom: 1px solid #f6f7fb;
}
.recent-color-box {
  width: 100%;
  margin: 14px 0 10px 0;
  padding: 0 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #666666;

  ul {
    width: 191px;
    height: 32px;
    display: flex;
    justify-content: flex-start;

    li {
      width: 32px;
      height: 32px;
      border: 1px solid #e6e6e6;
      border-radius: 4px;
      cursor: pointer;
      margin-left: 8px;

      &:first-child {
        margin-left: 0;
      }
    }
  }
}
.color-picker-box {
  width: 100%;
  padding: 0 30px;
}
.select-color-btn {
  width: 100%;
  padding: 0 30px;
  display: flex;
  justify-content: space-between;
  margin-top: 18px;

  div {
    width: 120px;
    height: 40px;
    line-height: 40px;
    border-radius: 4px;
    cursor: pointer;

    &:first-child {
      background-color: #ffffff;
      border: 1px solid #d5d5d5;

      &:hover {
        color: #2f58fe;
        border-color: #2f58fe;
      }
    }

    &:last-child {
      color: #ffffff;
      background-color: #2f58fe;

      &:hover {
        background-color: #3d7dff;
      }
    }
  }
}
</style>
